module.exports = "<app-payor-date-range-report reportPath=\"CreateErrorReport\" reportName=\"TacmsErrors\" isExcel=\"true\" title=\"Report Tacms Error\"></app-payor-date-range-report>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/manager-reports/tacms-error-report/tacms-error-report.component.html
// module id = 2470
// module chunks = 66